var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2085 10.0791C35.718 14.6288 34.6633 19.8429 31.0428 23.4635C27.5851 26.9213 22.6739 28.0387 18.2759 26.8173L10.59 34.5032C10.0943 34.9989 9.28573 34.9989 8.79003 34.5032L1.49672 27.2099C1.00109 26.7142 1.00109 25.9056 1.49672 25.4099L9.18265 17.724C7.96119 13.3261 9.07866 8.41483 12.5365 4.95707C16.157 1.33654 21.371 0.281924 25.9209 1.79146L17.4731 10.2392L19.2245 16.7755L25.7608 18.5268L34.2085 10.0791Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.26bf331e95111aeb13cbd54c5ddf5d3f.svg";
export { ForwardRef as ReactComponent };